import React from 'react';
import { motion } from 'framer-motion';
export function ComparisonSection() {
  const wrongApproach = ['"trucos rápidos"', 'culpan al cuerpo', 'ignoran la mente', 'no cambian hábitos'];
  return <section className="relative w-full bg-[#0a0a0a] py-8 md:py-12 overflow-hidden" data-id="element-31">
      <div className="absolute inset-0 z-0" data-id="element-32">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[500px] rounded-[100%] bg-red-900/10 blur-[120px]" data-id="element-33" />
      </div>

      <div className="relative z-20 max-w-5xl mx-auto px-6" data-id="element-34">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6" data-id="element-35">
          {/* Wrong */}
          <motion.div initial={{
          opacity: 0,
          x: -15
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="relative bg-gradient-to-b from-[#0a0a0a] to-black border border-red-900/40 p-6 md:p-7 rounded-lg" data-id="element-36">
            <h3 className="font-display text-lg md:text-xl uppercase mb-5 text-gray-400 flex items-center gap-2" data-id="element-37">
              <span className="text-red-500" data-id="element-38">⚠️</span> La mayoría (y falla)
            </h3>
            <ul className="space-y-2" data-id="element-39">
              {wrongApproach.map((item, index) => <li key={index} className="text-sm md:text-base text-gray-500 flex items-center gap-2" data-id="element-40">
                  <span className="text-red-500/50" data-id="element-41">✗</span> {item}
                </li>)}
            </ul>
          </motion.div>

          {/* Right */}
          <motion.div initial={{
          opacity: 0,
          x: 15
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="relative bg-gradient-to-b from-[#0a0a0a] to-black border border-red-600/50 p-6 md:p-7 rounded-lg shadow-[0_0_40px_rgba(220,38,38,0.15)] overflow-hidden" data-id="element-42">
            <div className="absolute inset-0 bg-red-600/5 blur-2xl" data-id="element-43" />
            <span className="absolute top-0 left-0 w-5 h-5 border-t-2 border-l-2 border-red-500" data-id="element-44" />
            <span className="absolute top-0 right-0 w-5 h-5 border-t-2 border-r-2 border-red-500" data-id="element-45" />
            <span className="absolute bottom-0 left-0 w-5 h-5 border-b-2 border-l-2 border-red-500" data-id="element-46" />
            <span className="absolute bottom-0 right-0 w-5 h-5 border-b-2 border-r-2 border-red-500" data-id="element-47" />

            <h3 className="relative font-display text-lg md:text-xl uppercase mb-5 text-white flex items-center gap-2" data-id="element-48">
              <span className="text-red-500" data-id="element-49">✔</span> Lo que haces aquí
            </h3>
            <p className="relative text-2xl md:text-3xl font-bold flex items-start gap-3" data-id="element-50">
              <span className="text-red-500 mt-1" data-id="element-51">👉</span>
              <span className="text-white drop-shadow-[0_0_15px_rgba(255,255,255,0.2)] leading-tight" data-id="element-52">
                Reprogramas desde la raíz
              </span>
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}